































































































































































import { Component, Mixins, Ref, Prop, Emit } from "vue-property-decorator";
import RulesMixin from "#/mixins/rulesMixin";
import UtilMixin from "@/mixins/utilMixin";
import {
  BiaggregateAisummaryPromptTemplate,
  DefaultBiaggregateAisummaryPromptTemplate,
  DefaultBiaggregateAisummaryPromptTemplateBlock,
} from "#/model/biaggregate";
import { VForm } from "@/types";
import OpenAISetting from "@/components/ai/OpenAISetting.vue";
import GeminiSetting from "@/components/ai/GeminiSetting.vue";
import ClaudeSetting from "@/components/ai/ClaudeSetting.vue";
import {
  LLM_TYPE,
  LLM_TYPES,
  BLOCK_TYPE,
  BLOCK_TYPES,
  BLOCK_TYPE_COLORS,
} from "@/views/biaggregate/const";

@Component({ components: { OpenAISetting, GeminiSetting, ClaudeSetting } })
export default class extends Mixins(UtilMixin, RulesMixin) {
  /** フォーム操作用 */
  @Ref("form") private readonly form!: VForm;

  /** 集計AIサマリプロンプトテンプレート */
  @Prop({ default: () => DefaultBiaggregateAisummaryPromptTemplate() })
  private promptTemplate!: BiaggregateAisummaryPromptTemplate;

  /** コピーモードフラグ */
  @Prop({ default: () => false })
  private isCopyMode!: boolean;

  /** 変数 */

  /** LLM種類(定数) */
  private LLM_TYPE = LLM_TYPE;

  /** LLM種類(選択肢) */
  private LLM_TYPES = LLM_TYPES;

  /** ブロックタイプ(定数) */
  private BLOCK_TYPE = BLOCK_TYPE;

  /** ブロックタイプ(選択肢) */
  private BLOCK_TYPES = BLOCK_TYPES;

  /** ブロックタイプ(チップ色) */
  private BLOCK_TYPE_COLORS = BLOCK_TYPE_COLORS;

  /** ブロックタイプ切替ダイアログ */
  private blockTypeChangeDialog = false;

  /** ブロックタイプ切替対象ブロックindex */
  private changeTargetBlockIndex = -1;

  /** ブロックタイプ切替対象ブロックタイプ */
  private changeTargetBlockType = BLOCK_TYPE.USER;

  /** ブロックタイプ(選択可能選択肢) */
  private get CHOICEABLE_BLOCK_TYPES() {
    return this.BLOCK_TYPES.filter((item) => item.value !== BLOCK_TYPE.SYSTEM);
  }

  /** ブロック追加(指定indexの直下にユーザープロンプトブロックを追加) */
  private addBlock(index: number) {
    this.promptTemplate.blocks.splice(
      index + 1,
      0,
      DefaultBiaggregateAisummaryPromptTemplateBlock()
    );
  }

  /** ブロック削除(システムプロンプトは削除不可) */
  private removeBlock(index: number) {
    this.promptTemplate.blocks.splice(index, 1);
  }

  /** チップクリック(システム以外はタイプ切替ダイアログ表示) */
  private onClickChip(index: number, blockType: number) {
    if (blockType == BLOCK_TYPE.SYSTEM) {
      return;
    }

    this.changeTargetBlockIndex = index;
    this.changeTargetBlockType = blockType;
    this.blockTypeChangeDialog = true;
  }

  /** ブロックタイプ変更確定 */
  private onChangeBlockType() {
    if (this.changeTargetBlockIndex >= 0) {
      this.promptTemplate.blocks[this.changeTargetBlockIndex].block_type =
        this.changeTargetBlockType;
    }
    this.resetChangeBlockType();
  }

  /** ブロックタイプ変更キャンセルリセット */
  private resetChangeBlockType() {
    this.changeTargetBlockIndex = -1;
    this.changeTargetBlockType = BLOCK_TYPE.USER;
    this.blockTypeChangeDialog = false;
  }

  private async confirmSavePrompt() {
    if (!this.form.validate()) {
      await this.$openAlert("入力内容に不備があります。");
      return;
    }
    if (!(await this.$openConfirm("保存しますか？"))) {
      return;
    }

    this.savePrompt();
  }

  private async confirmDeletePrompt() {
    if (!(await this.$openConfirm("削除します。よろしいですか？"))) {
      return;
    }

    this.deletePrompt();
  }

  /** キャンセルボタンクリック */
  private async onClickCancel() {
    if (
      await this.$openConfirm(
        "編集を終了します。\n編集中の場合は内容が破棄されます。"
      )
    ) {
      this.cancelPrompt();
    }
  }

  /** プロンプトバリデーションチェック */
  private checkPrompt(index: number): string | boolean {
    const target = this.promptTemplate.blocks[index];
    const messages: string[] = [];

    // ユーザープロンプトは空欄NG
    if (target.block_type == BLOCK_TYPE.USER && target.block_text === "") {
      messages.push("ユーザープロンプトは必ず入力してください。");
    }
    // ユーザープロンプトは最低1つ必要
    const userBlocks = this.promptTemplate.blocks.filter(
      (b) => b.block_type == BLOCK_TYPE.USER
    );
    if (!userBlocks || userBlocks.length === 0) {
      messages.push("ユーザープロンプトを最低1箇所設定してください。");
    }

    // 動的プロンプトは空欄でも良いが、必ずちょうど1つ必要
    const variableBlocks = this.promptTemplate.blocks.filter(
      (b) => b.block_type == BLOCK_TYPE.VARIABLE
    );
    if (!variableBlocks || variableBlocks.length !== 1) {
      messages.push("動的プロンプトを1箇所だけ設定してください。");
    }

    const message = messages.join("");

    return message === "" ? true : message;
  }

  /** Emit */

  @Emit("save:prompt")
  private savePrompt() {
    return;
  }

  @Emit("delete:prompt")
  private deletePrompt() {
    return;
  }

  @Emit("cancel:prompt")
  private cancelPrompt() {
    return;
  }
}
